import { render, staticRenderFns } from "./ModalStationEdit.vue?vue&type=template&id=0bf20fcb&scoped=true"
import script from "./ModalStationEdit.vue?vue&type=script&lang=js"
export * from "./ModalStationEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf20fcb",
  null
  
)

export default component.exports